import { useFlags } from "launchdarkly-react-client-sdk";

import AccountUserDetails from "AccountUserDetails";
import createAbsolutePath from "createAbsolutePath";
import NavBarItemDropdownMenu from "Header/NavBarItemDropdownMenu";
import { ActiveProfileQuery } from "operations";

export const mySettings = {
  label: "My settings",
  route: createAbsolutePath("/accounts/settings"),
};
export const helpCenter = {
  label: "Help Center",
  route: "https://help.jooraccess.com/en",
};
export const logout = {
  label: "Logout",
  route: createAbsolutePath("/users/logout"),
};

const NavBarProfileDropdown = ({
  account,
}: Pick<ActiveProfileQuery, "account">) => {
  const { showRetailIntegrationsSettings } = useFlags();
  return (
    <NavBarItemDropdownMenu
      value={<AccountUserDetails account={account} />}
      options={[
        ...(showRetailIntegrationsSettings ? [mySettings] : []),
        helpCenter,
        logout,
      ]}
    />
  );
};

export default NavBarProfileDropdown;
